export default "__VITE_ASSET__Cmz3P93C__"